module.exports = __webpack_public_path__ + "28e35277ee51315379e2dec179a06ee3.pdf";